// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import * as React from 'react';

export const NoLayout: React.FC<React.PropsWithChildren> = ({ children }) => (
    <>
        {children}
    </>
);
